export default __webpack_public_path__ + "static/media/logo.81b035f0.ico";